module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickothers",
      rawName: "v-clickothers",
      value: (_vm.clickOthers),
      expression: "clickOthers"
    }],
    class: _vm.component_class,
    style: (_vm.custom_style.self)
  }, [_c('div', {
    staticClass: "handler",
    on: {
      "click": _vm.clickHandler,
      "mouseenter": function($event) {
        _vm.hoverHandler(true)
      },
      "mouseleave": function($event) {
        _vm.hoverHandler(false)
      }
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.float || !_vm.show_val),
      expression: "float || !show_val"
    }],
    staticClass: "label",
    class: {
      float: _vm.show_val && _vm.float
    }
  }, [_vm._v(_vm._s(_vm.label || (_vm.show_val ? '已选择' : '请选择')) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "selected",
    class: {
      float: _vm.show_val && _vm.float
    }
  }, [_vm._v(_vm._s(_vm.show_val))]), _vm._v(" "), _c('span', {
    staticClass: "arrow",
    style: (_vm.custom_style.arrow)
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "select-slide-down"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_active),
      expression: "is_active"
    }],
    staticClass: "body"
  }, [_vm._t("default", _vm._l((_vm.data), function(item, index) {
    return _c('SelectItem', {
      key: index,
      attrs: {
        "color": _vm.color,
        "active": _vm.value_by ? _vm.value === item[_vm.value_by] : item === _vm.value
      },
      on: {
        "click": function($event) {
          _vm.itemClick(item, index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item[_vm.show_by] || item) + "\n        ")])
  }))], 2)]), _vm._v(" "), _c('input', {
    ref: "tab_hack",
    staticClass: "tab-hack",
    attrs: {
      "type": "text"
    },
    on: {
      "focus": function($event) {
        _vm.is_active = true
      },
      "blur": function($event) {
        _vm.is_active = false
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disabled),
      expression: "disabled"
    }],
    staticClass: "disabled-mask"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db50eb9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Select/Select.vue
// module id = 694
// module chunks = 0